import React from 'react';
import { Link } from 'react-router-dom';
import {FaBuilding, FaChartLine } from 'react-icons/fa';
import './RectorateDashboard.css';

function RectorateDashboard() {
    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Rektorat-Dashboard</h2>
            <div className="dashboard-links">
                <Link to="/mdb/rectorate/overview" className="dashboard-link">
                    <FaBuilding className="icon" />
                    Übersicht der Mitverwendungen
                </Link>
                <Link to="/mdb/rectorate/statistic" className="dashboard-link">
                    <FaChartLine className="icon" />
                    Statistik
                </Link>
            </div>
        </div>
    );
}

export default RectorateDashboard;

